import {Base, VirtualEventConfig, SocketIf, Participant} from "socket_if"

export default class dispatcher {
  constructor(connection, store, router) {
    this.connection = connection
    this.event = VirtualEventConfig.event
    this.store = store
    this.router = router
  }

  authParticipants() {
    const currentRoute = this.router.currentRoute
    const hallSlug = currentRoute.params.hallSlug
    let roomSlug = currentRoute.params.roomSlug
    const talkRoomName = currentRoute.params.roomName
    const user = this.store.getters["auth/user"]

    if (currentRoute.name === "HRoom") {
      roomSlug = "hall_room"
    } else if (currentRoute.name === "TalkRoom" && talkRoomName) {
      roomSlug = talkRoomName
    } else if (["YRoomEntry", "TalkRoomEntry"].some(route => route === currentRoute.name)) {
      if (talkRoomName) roomSlug = talkRoomName

      roomSlug += "_entry"
    }

    const participant = new Participant(
      _.assign(user, {
        userId: user.id,
        avatar: user.icon_url,
        hall: hallSlug || this.store.getters["hall/main"].slug,
        room: roomSlug || null
      })
    )
    this.connection.emit(this.event.client_server.auth_participants, this.buildRequest(participant).toString())
  }

  sendDirectMessage(message) {
    this.connection.emit(this.event.client_server.send_direct_messages, this.buildRequest(message).toString())
  }

  inviteDirectMessage(message) {
    this.connection.emit(this.event.client_server.invite_direct_messages, this.buildRequest(message).toString())
  }

  updateDirectMessageToRead(message) {
    this.connection.emit(this.event.client_server.update_direct_messages_to_read, this.buildRequest(message).toString())
  }

  sendRoomMessage(message) {
    this.connection.emit(this.event.client_server.send_room_messages, this.buildRequest(message).toString())
  }

  removeRoomMessage(messages) {
    this.connection.emit(this.event.client_server.remove_room_messages, this.buildRequest(messages).toString())
  }

  moveParticipant(participant) {
    this.connection.emit(this.event.client_server.move_participants, this.buildRequest(participant).toString())
  }

  emitNotice(notice) {
    this.connection.emit(this.event.client_server.emit_notices, this.buildRequest(notice).toString())
  }

  emitLiveQuestionnaire(questionnaire) {
    this.connection.emit(this.event.client_server.emit_per_live_questionnaire, this.buildRequest(questionnaire).toString())
  }

  buildRequest(body) {
    return new SocketIf({
      authentication: this.store.getters["auth/token"],
      participantId: this.store.getters["auth/id"],
      event: this.store.getters["event/slug"],
      body: body
    })
  }
}
